
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`ეს ინსტრუმენტი საშუალებას გაძლევთ შეასწოროთ ინგრედიენტების სია. შეგიძლიათ დაამატოთ, წაშალოთ ან შეცვალოთ
                ინგრედიენტების სია.
                <br>
                ეს სიმბოლო <span class="highlight">␣</span> წარმოადგენს ინტერვალს.
                <br>
                ეს სიმბოლო <span class="highlight">↩︎</span> წარმოადგენს ხაზის გაწყვეტას. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `თვისებები იტვირთება...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `დაგვეხმარეთ ინგრედიენტებით`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `მოსავლის დადასტურება`,
's03e9c8114521b998': `ინგრედიენტებს შევასწორებ`,
's05ec315d9308091a': `შტრიხკოდის კუთხეების ხატულა`,
's061eb5af92512c85': `შენახულია! შეგიძლიათ კიდევ ერთით დამეხმაროთ?`,
's06847c221c4c0bc1': `მსურს შევქმნა თვისება [აღწერეთ თქვენი გამოყენების შემთხვევა]...`,
's06f6c6f99db6b552': `ორიგინალი`,
's081e2ad82db71e1d': `დაჯგუფებული მნიშვნელობები`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `სპეციალური დოკუმენტაცია`,
's0bb2d48532acc455': `ჩამოტვირთეთ CSV ფაილი`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `სურათის გაუქმება`,
's100c4928cc74642a': `საზოგადოებრივი ჯანდაცვის კვლევის წინსვლის მხარდაჭერა.`,
's10db5498186c083b': `ჩამოჭრის გაუქმება`,
's11a18a69b30b65ed': `დაგვეხმარეთ ინგრედიენტების სიაში არსებული შეცდომების გამოსწორებაში`,
's1205d5f6fccf8e69': `ქონების ღირებულება`,
's15d64a0a6715285a': `ახალი გასაღები`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `შერჩევის არეალი`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `დაგვეხმარეთ კვებითი ღირებულების შესახებ ინფორმაციის გასწორებაში`,
's1e00019dc454872d': `გთხოვთ, მიუთითოთ თვისების სახელი property-name ატრიბუტის გამოყენებით.`,
's1e49126af0935a5b': `ამ თვისების გამოყენებით პროდუქტების სია`,
's21e73088de6f26f3': `ჩამოტვირთეთ App Store-დან`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `ქონების დოკუმენტირება`,
's300b3a6ee4e1252d': str`ცუდი შესაბამისობა ${0}%`,
's33f786bb6b4f0cf4': `მოსავლის შედეგი`,
's33f85f24c0f5f008': `შენახვა`,
's34be4af4e8fec4ae': `ჯერ საზოგადოებას ჰკითხეთ`,
's36d86adc823cbfa6': `ახალი ქონების შექმნამდე, განიხილეთ ეს საზოგადოებასთან:`,
's3781d25aa51a736c': `ფოლკსონომიის ძრავის დოკუმენტაცია`,
's383ae4449428b61e': `ჩამოჭრის გადატვირთვა`,
's39bcf88721a1e8ee': `არჩევანის გადაყენება`,
's39e14e14300694c7': `დოკუმენტაცია და ინსტრუქციები`,
's3b430cfa5c1fe7f4': str`დოკუმენტაცია ${0}-ისთვის`,
's3f4e4b52f230a892': `სურათის ტილო`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `ცენტრის სურათი`,
's42dd66b2441566fd': `ცენტრის ხატულა`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `ზომის შეცვლა მარჯვნივ`,
's475b08749d0706ed': `დაგვეხმარეთ, მთელ მსოფლიოში მილიონობით მომხმარებელს ვაცნობოთ, თუ რას მიირთმევენ`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `პროდუქციის რაოდენობა`,
's4df2f533c0c1e7d0': `სურათის მართვის საშუალებები`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `არჩევანის გადატანა`,
's4f751fb9b3ed766c': `ახალი ქონების შექმნა`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `შეიყვანეთ ქონების სახელი...`,
's55d7249883a98ca1': `ამ ქონების შესახებ Open Food Facts ვიკიზე`,
's565867d84c04aea2': `ფილტრის თვისებები...`,
's5666afe5cd0166de': `გთხოვთ, დადასტურებამდე გამოასწოროთ შეცდომები ან შეცვალოთ ტექსტი`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `პროდუქტები იტვირთება...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `დაგვეხმარეთ კვებითი ღირებულების შესახებ ინფორმაციის გასწორებაში.`,
's5dd6f12783fca34f': `ინგრედიენტების სიის რედაქტირება`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `მე მხარს ვუჭერ`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `ჩამოჭრილი სურათი`,
's6d7b6cdedaadfb6e': `თითოეული შემოწირულობა მნიშვნელოვანია! ჩვენ ვაფასებთ თქვენს მხარდაჭერას მსოფლიოში საკვების გამჭვირვალობის გაზრდის საქმეში.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`კარგი შესაბამისობა ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `დოკუმენტაცია`,
's787dd11bed0dc88a': `ზომის შეცვლა მარცხნივ`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `შეიტყვეთ მეტი ქონების შექმნისა და ინსტრუქციების შესახებ:`,
's8038273de2cf8b73': `გთხოვთ, აირჩიოთ რეგიონი დასაჭრელად.`,
's839cc2908a5387f2': `შტრიხკოდების ფილტრაცია...`,
's86197dcf3e96af64': `არსებული უძრავი ქონების დათვალიერება და ძიება`,
's8a63be30a129a59c': `ქვედა ნაწილის ზომის შეცვლა`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `ზომის შეცვლა ზედა მარჯვენა კუთხეში`,
's8db84aa4bc949af2': `ახალი ქონების დოკუმენტირება`,
's8f839a03997a16d7': `პროდუქტის ნახვა`,
's901ae1e236ac45d3': `წაშლის გაუქმება`,
's907f7a97c6b29425': `გაითვალისწინეთ, რომ მონაცემთა მოდელი შესაძლოა შეიცვალოს. გამოიყენეთ საკუთარი რისკის ქვეშ.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `ინგრედიენტები:`,
's9a7f60fce090ecaf': `თვისებების ჩატვირთვა ვერ მოხერხდა. გთხოვთ, სცადოთ მოგვიანებით.`,
's9b87abd68fb9df45': `ვერ მოიძებნა? შექმენით ახალი გასაღები {value}`,
's9c0f52425fd2f07e': `შესაძლოა არ ემთხვეოდეს`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `ქულა მიუწვდომელია`,
'sa548778b24054030': `გაეცანით Folksonomy Engine პროექტიდან შემოტანილ ყველა თვისებას. ეს თვისებები გთავაზობთ დამატებით მეტამონაცემებს და ინფორმაციას Open Food Facts მონაცემთა ბაზაში არსებული პროდუქტების შესახებ.`,
'sa63907958bd0ec4b': `ზომის შეცვლა ზედა მარცხენა კუთხეში`,
'sa95b4224f685a36a': `მოდალური დახურვა`,
'sab56a1d439576fd6': `შეთავაზების ხატულა`,
'sac47ea2901d04c15': `ზომის შეცვლა ქვედა მარცხენა კუთხეში`,
'sb125227d436c2925': `მოძებნეთ თქვენი ქონების კონცეფცია არსებულ ქონების მონაცემთა ბაზაში:`,
'sb125568d43642e6f': `უპასუხეთ კითხვებს პროდუქტთან დაკავშირებით.`,
'sb1c538e038f9b214': str`ძალიან კარგი შესაბამისობა ${0}%`,
'sb28639570ff3b852': `ყველა ქონების სია`,
'sb3bdd638a58d30f4': `ჩაერთონ ერთგული მოქალაქეების საზოგადოებაში,`,
'sb3cbcc1bd0fff140': `მას შემდეგ, რაც დაადასტურებთ, რომ თქვენი ქონება არ არსებობს და საზოგადოება დაეთანხმება მის სასარგებლოობას, ჯერ ის ვიკიში უნდა ასახოთ.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `ამ ქონებისთვის პროდუქტები ვერ მოიძებნა.`,
'sb7f72e4c8a2d3357': `ფილტრის მნიშვნელობები...`,
'sb8178320160f84ea': `ჩამოჭრის ჩვენება`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `ყველა მოსაზრებას პასუხი გაეცა! გმადლობთ დახმარებისთვის!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `შესაბამისი ღირებულება`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `ზედა ნაწილის ზომის შეცვლა`,
'sc1c08d0cbcc3bd24': `არ ემთხვევა`,
'sc52696641af72b53': `დააინსტალირეთ აპლიკაცია!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `შემოთავაზებული შესწორება`,
'sc681b137e8f604f7': `წაშლის დადასტურება`,
'sc6daf8a31883f8b9': `სურათის გადატანა`,
'sc895972c88d38ca5': `ფოლკსონომიის თვისება`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `რიგები`,
'scb3b0671d7b7f640': `ახალი ღირებულება`,
'scb489a1a173ac3f0': `დიახ`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `შემოუერთდით Slack-ის დისკუსიას`,
'scdb6cad0b92721bf': `თვისებები ვერ მოიძებნა.`,
'scf23a05631f93732': `დაადასტურეთ წაშლა`,
'scfed2f270ef6a3aa': `აირჩიეთ ტერიტორია`,
'sd1022bc1ef9204f7': `მასშტაბირებადი სურათი`,
'sd1077c055cf9ba6b': `დაგვეხმარეთ პროდუქტის ინგრედიენტების სიის დადასტურებაში.`,
'sd698d21ddecba56b': `გამარჯობა! თქვენ შეგიძლიათ დაგვეხმაროთ პროდუქტის ინფორმაციის გაუმჯობესებაში შემდეგ კითხვებზე პასუხის გაცემით:`,
'sd82bc2decefa621b': `დარჩეს დამოუკიდებელი კვების ინდუსტრიისგან,`,
'sdb97e5976482606e': `შეამოწმეთ, უკვე არსებობს თუ არა ქონება`,
'sdbf806fefc584115': `თქვენ უნდა იპოვოთ`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `დაგვეხმარეთ ინგრედიენტების ორთოგრაფიული შეცდომების გასწორებაში.`,
'sdca5deead576ceee': `ზომის შეცვლა ქვედა მარჯვენა კუთხეში`,
'sdcc2555c5dde524f': `დარწმუნებული ხართ, რომ გსურთ ამ ერთეულის წაშლა? ამ მოქმედების გაუქმება შეუძლებელია.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `ბათილად ცნობა`,
'se5127cf0f92e7e48': `რჩევა: ასევე შეგიძლიათ იპოვოთ`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `უკეთეს მოსავალს შემოგთავაზებთ`,
'seea3800e27baa686': `ინდივიდუალური პროდუქტები`,
'sefaba4adc4ec9219': `ფოლკსონომიის თვისებები`,
'seffa8ca49175b5f0': `პერსონალიზებული თვისებები`,
'sf44a6b3b232c28ea': str`მიმდინარე მნიშვნელობა შეცვალეთ ${0}-ით`,
'sf4cd86a2f5ef2588': `პროდუქტის შტრიხკოდი`,
'sf57a61152168cc81': `დაგვეხმარეთ ინგრედიენტების ამოცნობის გამოსწორებაში`,
'sf88b90b8ba23871c': `უცნობი დამთხვევა`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `ქონების დასახელება:`,
'sfc40ea3d5d5aa6f8': `თქვენი შემოწირულობები აფინანსებს ჩვენი არაკომერციული ასოციაციის ყოველდღიურ საქმიანობას:`,
'sfe87465d50530725': `შესაბამისი მნიშვნელობა`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  